<template lang="pug">
.sv-checkbox(:class="disable ? 'sv-checkbox__disable': ''")
    label.sv-checkbox__label(
        @mouseover="hovered(true)"
        @mouseleave="hovered(false)"
    )
        input.sv-checkbox__input(
            type="checkbox"
            :checked="isChecked"
            :disabled="disable ? 'disabled' : false"
            @change="changeVal"
        )

        SvIcon.sv-checkbox__icon(
            :icon="checkIcon"
            :width="20"
            :height="20"
        )

        .sv-checkbox__content
            slot
                | {{ label }}
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';

export default {
  name: 'SvCheckbox',

  model: {
    prop: 'checked',
    event: 'input',
  },

  props: {
    checked: {
      type: [Array, String, Boolean],
      default: false,
    },

    value: {
      type: [String, Boolean, Number],
      default: true,
    },

    label: {
      type: String,
      default: '',
    },

    disable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isHovered: false,
    };
  },

  computed: {
    checkIcon() {
      if (this.isChecked) {
        return 'checkbox-check';
      }
      return this.isHovered ? 'checkbox-hover' : 'checkbox-unchecked';
    },

    isChecked() {
      if (Array.isArray(this.checked)) {
        return !!this.checked.find(v => v === this.value);
      }
      return this.value === this.checked;
    },
  },

  methods: {
    hovered(val) {
      this.isHovered = val;
    },

    changeVal() {
      if (Array.isArray(this.checked)) {
        const idx = this.checked.findIndex(v => v === this.value);
        if (idx !== -1) {
          const arr = this.checked.slice();
          arr.splice(idx, 1);
          this.$emit('input', arr);
        } else {
          const another = [...this.checked, this.value];
          this.$emit('input', another);
        }
      } else {
        this.$emit('input', !this.checked);
      }
    },
  },

  components: {
    SvIcon,
  },
};
</script>

<style lang="scss" scoped>
.sv-checkbox {
    &__disable {
      opacity: 0.5;
    }

    &__label {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    &__content {
        padding-left: 10px;
        line-height: 100%;
    }

    &__input {
        width: 20px;
        height: 20px;
        z-index: -1;
        opacity: 0;
        position: absolute;
    }

    &__icon {
      min-height: 20px;
      min-width: 20px;
      align-self: flex-start;
    }
}
</style>
